/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoadResultFile as AgentApiContractLoadResultFile } from '../../models/AgentApi/Contract/load-result-file';

export interface ApiAgentListLoadResultGet$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * download file sid
 */
  fileSid?: string;

/**
 * download status (0 - all; 1 - successfully downloaded maps; 2 - screened maps during download)
 */
  status?: number;

/**
 * File name
 */
  fileName?: string;
}

export function apiAgentListLoadResultGet(http: HttpClient, rootUrl: string, params?: ApiAgentListLoadResultGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractLoadResultFile>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListLoadResultGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('fileSid', params.fileSid, {});
    rb.query('status', params.status, {});
    rb.query('fileName', params.fileName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractLoadResultFile>;
    })
  );
}

apiAgentListLoadResultGet.PATH = '/api/Agent/ListLoadResult';
